var Options = {
  props: {
    /**
     * Leaflet options to pass to the component constructor
     */
    options: {
      type: Object,
      default: function () { return ({}); }
    }
  }
};

export default Options;



//////////////////
// WEBPACK FOOTER
// ./~/vue2-leaflet/dist/mixins/Options.js
// module id = 585
// module chunks = 0